import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './WatermelonPage.css';
import watermelonLogo from '../images/watermelon-logo.png';
import watermelonLiger from '../images/watermelon-liger-img.png';
import watermelonBalwan2025 from '../images/watermelon-balwan2025-img.png';
import watermelonSamrat905 from '../images/Watermelon-Samrat - 905-img.png';

const categories = [
  {
    key: 'bigSizeWatermelon',
    label: 'Big Size Watermelon',
    varieties: [
     
      
      
    ],
  },
  {
    key: 'iceBoxWatermelon',
    label: 'Ice Box Watermelon',
    varieties: [
     
      {
        name: 'LIGER',
        image: watermelonLiger,
        description: [
          'Icebox type watermelon with mini seeded oval-shaped fruits',
          'Strong and vigorous plants with high adaptability across India',
          'High fruit size uniformity and high yield potential',
          'Deep red crispy flesh with sweetness of 11-13% Brix',
          'Fruit size: 4-5 kg',
          'Very good shipping and keeping quality',
        ],
      },
      {
        name: 'BALWAN-2025',
        image: watermelonBalwan2025,
        description: [
          'Vigorous plant type with heavy bearing',
          'Multiple fruit set with pure dark black and shiny rind',
          'Oval fruits with pure deep red flesh, fruit weight 4-7 kg',
          'First harvest in about 65-70 days depending on season timing',
          'Tolerant to W.Y.M.V and Fusarium wilt',
          'Heat tolerant and survives high temperatures',
          'High demand in local and export markets',
        ],
      },
    ],
  },
  {
    key: 'roundTypeWatermelon',
    label: 'Round Type Watermelon',
    varieties: [
      
      {
        name: 'SAMRAT-95',
        image: watermelonSamrat905,
        description: [
          'Mid-early vigorous hybrid (80-85 days) with wide adaptability',
          'Suitable for Kharif and Summer (late Kharif and late Rabi also)',
          'Fruit shape: Oval to oblong',
          'Rind colour: Light green with dark green stripes',
          'Fruit weight: 10-12 kg',
          'Flesh colour: Crimson red',
          'Flesh taste: Sweet (TSS 12-13%) with granular texture',
          'High yield, good shelf life, and suitable for long distance transportation',
          'Recommended spacing: 6 ft x 1.5 ft',
        ],
      },
    ],
  },
];

// Flatten all varieties from all categories into a single array
const allVarieties = categories.reduce((acc, category) => {
  return [...acc, ...category.varieties];
}, []);

export default function WatermelonPage() {
  return (
    <ProductPatternPage
      title="Watermelon"
      varieties={allVarieties}
      pageClass="watermelon-page"
      heroImage={watermelonLogo}
    />
  );
}
